if (!customElements.get('md-header-brands')) {
  customElements.define(
    'md-header-brands',
    class MdHeaderBrands extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-md-header-brands-viewport]');
        this.track = this.querySelector('[data-md-header-brands-track]');
        this.previousButton = this.querySelector('[data-md-header-brands-prev]');
        this.nextButton = this.querySelector('[data-md-header-brands-next]');

        if (!this.viewport || !this.track) return;

        this.preventMouseFocus = (event) => event.preventDefault();

        this.previousButton?.addEventListener('mousedown', this.preventMouseFocus);
        this.nextButton?.addEventListener('mousedown', this.preventMouseFocus);
        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
      }

      getStep() {
        const item = this.track.querySelector('.md-header-brand-item');
        if (!item) return this.viewport.clientWidth;

        const styles = window.getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0');

        return item.getBoundingClientRect().width + gap;
      }

      move(direction) {
        const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const current = this.viewport.scrollLeft;
        const edgeTolerance = 2;

        if (direction > 0 && current >= maxScroll - edgeTolerance) {
          this.viewport.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }

        if (direction < 0 && current <= edgeTolerance) {
          this.viewport.scrollTo({ left: maxScroll, behavior: 'smooth' });
          return;
        }

        this.viewport.scrollBy({ left: direction * this.getStep(), behavior: 'smooth' });
      }
    },
  );
}
